// extracted by mini-css-extract-plugin
export var access = "thread-card-module--access--7aeb5";
export var author = "thread-card-module--author--42deb";
export var comment = "thread-card-module--comment--2007d";
export var container = "thread-card-module--container--b29e1";
export var dot = "thread-card-module--dot--88eb8";
export var footer = "thread-card-module--footer--a9234";
export var header = "thread-card-module--header--08366";
export var locked = "thread-card-module--locked--4c7e3";
export var meta = "thread-card-module--meta--05b02";
export var pin = "thread-card-module--pin--07903";
export var publicThread = "thread-card-module--public-thread--90dcf";
export var title = "thread-card-module--title--ec956";
export var unlocked = "thread-card-module--unlocked--5fda9";